import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { QuestionCircleOutlined, MenuOutlined, CloseOutlined, PoweroffOutlined, NotificationOutlined, BellOutlined, MailOutlined } from '@ant-design/icons'
import './Header.scss'
import { useSelector } from 'react-redux';
import { selectorInfoUser, setInfoUser } from '../../store/slices/infoUserSlice';
import { Badge, Drawer, Dropdown, Select, Tabs } from 'antd';
import useResetData from '../../hook/useResetData';
import { MenuProps } from 'antd/lib';
import { URL_AVATAR } from '../../env';
import { avatarDefault, noData } from '../ExportImgFigma';
import { selectorUnitByUserPermission } from '../../store/slices/UnitByUserPermission';
import { fommatSelectOptionUnitByUser, getDeepestFirstChildUrl, gListUnitByUserPermission, gPermissionUnit, setMenuAndPermission } from '../../until';
import { useDispatch } from 'react-redux';
import { DebounceSelect_V2 } from '../Select/Select_V2';
import useDebounce from '../../hook/useDebounce';
// import { getFirstChildMenuUrl } from '../../pages/Login';
import { selectorMenu, setMenu } from '../../store/slices/menuSlice';

interface INotification {
  id: number;
  content: string;
  time: string;
}

const MOCK_NOTIFICATIONS: INotification[] = [
  { id: 1, content: 'Khách hàng Nguyễn Văn A sẽ bị xóa vĩnh viễn sau 5 ngày nữa. Hãy kiểm tra và khôi phục nếu cần thiết trước ngày 30/06/2025', time: '13:55 06/06/2025' },
  { id: 2, content: 'Đồng bộ dữ liệu khách hàng 100.000 dữ liệu từ kho dữ liệu vào CRM thất bại.', time: '13:54 05/06/2025' },
  { id: 3, content: 'Nhóm khách hàng Nhóm miền nam sẽ bị xóa vĩnh viễn sau 5 ngày nữa. Hãy kiểm tra và khôi phục nếu cần thiết trước ngày 30/06/2025', time: '13:40 03/06/2025' },
  { id: 4, content: 'User1 đã chia sẻ nhóm Nhóm đơn vị 181 với bạn.', time: '13:30 02/06/2025' },
  { id: 5, content: 'User5 đã thêm khách hàng Nguyễn Văn A vào nhóm Nhóm miền nam của bạn', time: '13:20 01/06/2025' },
];

const TAB_ITEMS = [
  { key: 'kh', label: 'Khách hàng', notifications: MOCK_NOTIFICATIONS },
  { key: 'cskh', label: 'CSKH tự động', notifications: [] },
  { key: 'cham-soc', label: 'Chăm sóc khách hàng', notifications: [] },
  { key: 'khac', label: 'Khác', notifications: [] },
];


const AppHeader: React.FC = () => {
  const unitByUserPermissionSlice = useSelector(selectorUnitByUserPermission)
  const { id, username, image, unit, groupPermission, role, unitTemp } = useSelector(selectorInfoUser)
  const initialState = {
    unit: unit,
    id: id,
    username: username,
    image: image,
    groupPermission: groupPermission,
    role: role,
    unitTemp: unitTemp
  }
  const location = useLocation();
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { resetLoginExpired } = useResetData()

  const menuSlice = useSelector(selectorMenu)

  const didRun = useRef(false);
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenNotification, setIsOpenNotification] = useState(false)
  const [valueUnit, setValueUnit] = useState<number>()
  const [defaultValueUnit, setdefaultValueUnit] = useState<number>(unit)

  const triggerMenu = () => {
    const appWidget = document.getElementsByClassName('app-widget')[0]
    setIsOpen(!isOpen)
    appWidget.classList.toggle('app-widget-show')
  }

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <span className='cursor-pointer text-sm font-regular'
        >
          Thông tin tài khoản
        </span>
      ),
    },
    {
      key: '2',
      label: (
        <div className='d-flex align-center gap-2'
        >
          <span className='cursor-pointer text-FA541C text-sm font-regular'>Đăng xuất</span>
          <PoweroffOutlined className='text-FA541C text-base' />
        </div>
      ),
    }
  ];
  const handleClickMenu: MenuProps['onClick'] = ({ key }) => {
    if (key === '1') {
      navigate('/system-configuration/accounts-information')
    } else if (key === '2') {
      navigate('/login')
      resetLoginExpired()
    }
  };


  // const setDataUser = async (token: string, data: loginApi.IUser) => {
  //   setInfoUserData(data)
  //   if (isSaveAccount) {
  //     setAccountPasswordUser(username, password)
  //   } else {
  //     clearAccountPasswordUser()
  //   }
  //   tokenService.setToken(token)
  //   gListGroupCustomer()

  //   const result = await loginApi.permissionUser(data.unit, data.groupPermission ?? undefined)
  //   if (result?.status) {
  //     dispatch(setPermission(result.dataMenu))
  //     gListmenu(data.unit)
  //   }


  // }

  const handleChangeValue = async (value: number) => {

    if (value !== undefined) {
      setValueUnit(value)
      // gPermissionUser(value, undefined, dispatch)

      dispatch(setInfoUser({ ...initialState, unitTemp: value }))
      setMenuAndPermission(value, dispatch, navigate, location.pathname)
    } else {
      setValueUnit(defaultValueUnit)
      debouncedSearch("")

      dispatch(setInfoUser({ ...initialState, unitTemp: defaultValueUnit }))
      setMenuAndPermission(Number(defaultValueUnit), dispatch, navigate, location.pathname)
    }
  }

  const debouncedSearch = useDebounce((search: string) => {
    gListUnitByUserPermission(id, dispatch, search);
  }, 500);

  useEffect(() => {
    if (unitByUserPermissionSlice.length === 1) {
      const valueTamp = unitByUserPermissionSlice.map((item) => item.unitId)
      setValueUnit(valueTamp[0])
    } else {
      if (!unitTemp) {
        dispatch(setInfoUser({ ...initialState, unitTemp: unit }))
        setValueUnit(unit)
      } else {
        setValueUnit(unitTemp)
      }

      if (!didRun.current) {
        setdefaultValueUnit(unit)
        didRun.current = true
      }
    }
  }, [unitByUserPermissionSlice, unitTemp])

  return (
    <div className="app-header">
      <Drawer
        title="Thông báo"
        placement="right"
        width={400}
        open={isOpenNotification}
        onClose={() => setIsOpenNotification(false)}
        className="notification-drawer"
        styles={{ body: { padding: 0 } }}
      >
        <Tabs
          defaultActiveKey="kh"
          className="notification-tabs"
          tabBarGutter={0}
          tabBarStyle={{ padding: 0, margin: 0 }}
          items={TAB_ITEMS.map((tab) => ({
            key: tab.key,
            label: tab.label,
            children: (
              <div className="notification-list">
                {tab.notifications.length === 0 ? (
                  <div
                    style={{
                      textAlign: 'center',
                      padding: 20
                    }}>
                    <br />
                    <img src={noData} alt="No data"

                      style={{
                        maxWidth: 150,
                      }} />
                    <br />
                    <div>Không có dữ liệu</div>
                    <br />
                  </div>
                ) : (
                  tab.notifications.map((item) => (
                    <div key={item.id} className="notification-item">
                      <div className="notification-icon">
                        <MailOutlined />
                      </div>
                      <div className="notification-body">
                        <div className="notification-content">{item.content}</div>
                        <div className="notification-footer">
                          <span className="notification-time">{item.time}</span>
                          <span className="notification-link">Xem chi tiết</span>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            ),
          }))}
        />
      </Drawer>
      {/* <Link to={'/'} className="app-header-left">
        <img src="/logo.svg" alt="THACO AUTO CRM" />
      </Link> */}
      <Link
        // to={''}
        to={`${getDeepestFirstChildUrl(menuSlice, true)}`}
        className="h-full flex items-center pl-4"
      >
        {/* <Link to={`/customer/list`} className="h-full flex items-center pl-4"> */}
        {/* <img src="/logo.svg" alt="THACO AUTO CRM" className="default-logo"/> */}
        <div className="logo-header">
          <img src="https://thacoauto.vn/storage/logo/logo-thacoauto-2023.png" alt="THACO AUTO CRM" className="" />
        </div>
        {/* <img src="https://bdata.vn/img/bdata-logo-new-2.png" alt="THACO AUTO CRM" className="default-logo" /> */}
      </Link>

      <div className="app-header-right">
        <div className='w-300-px'>
          <DebounceSelect_V2<any>
            style={{ width: "100%" }}
            placeholder="Chọn đơn vị"
            disabled
            showSearch
            allowClear
            value={valueUnit}
            defaultValue={unit}
            options={fommatSelectOptionUnitByUser(unitByUserPermissionSlice)}
            onChange={(e) => handleChangeValue(e)}
            onSearch={debouncedSearch}
          />
        </div>
        {/* <div className="item">
          <QuestionCircleOutlined />
        </div> */}
        <div className="item" onClick={() => setIsOpenNotification(true)}>
          <Badge count={MOCK_NOTIFICATIONS.length} overflowCount={99}>
            <BellOutlined style={{ fontSize: 20 }} />
          </Badge>
        </div>
        <div className="item">
          <Dropdown menu={{ items, onClick: handleClickMenu }} placement="bottomRight" trigger={["hover"]}>
            <div className="avatar-trigger">
              <img src={URL_AVATAR + image} alt="" onError={(e) => {
                e.currentTarget.src = avatarDefault;
              }} />
              <span className="name">{username}</span>
            </div>
          </Dropdown>

        </div>
        <div
          className="item menu-trigger"
          onClick={triggerMenu}
        >
          {
            isOpen
              ? <CloseOutlined />
              : <MenuOutlined />
          }
        </div>
      </div>
    </div>
  );
}

export default AppHeader;
